import { Component, Input } from '@angular/core';
import { SectionReference } from 'src/app/models/section-reference';

/**
 * A section's references: a list of titled links with one "Last checked" month under it.
 * A heading in the list, such as a state's name, is shown in bold above the references it groups.
 * A section whose references have not been split into a list yet sends only free text,
 * which is shown as it always was.
 */
@Component({
  selector: 'app-section-references',
  templateUrl: './section-references.component.html',
  styleUrls: ['./section-references.component.scss'],
})
export class SectionReferencesComponent {

  @Input()
  public references: SectionReference[];

  /** ISO date on which the references were last checked. Shown by month. */
  @Input()
  public checkedOn: string | null;

  /** The references as free-text HTML, for a section with no list */
  @Input()
  public legacyHtml: string;

  public get hasList(): boolean {
    return !!this.references && this.references.length > 0;
  }

  public get legacyReferences(): string {
    if (!this.legacyHtml) return '';

    // First handle periods before closing paragraph tags
    const text = this.legacyHtml.replace(/\.(<\/p>)/g, '$1');

    // Then process URLs
    return text.replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );
  }
}
